




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface CatalogCompensation {
    catalogCode: string;
}

@Component({ components: { SimpleText } })
export default class Code extends Vue {
    @Prop( { default: null }) public catalogCompensation !: CatalogCompensation;

    public static getNeededFields(): string[] {
        return [
            "catalog.catalogCode",
        ];
    }
}
